import {isCmsBuilderPath} from '../utils/cmsBuilderRoutes.mjs';
import {canResolveCmsRoute, normalizeCmsPath, replaceCmsRoute} from '../utils/cmsUrlRouting.mjs';

export default defineNuxtRouteMiddleware(async to => {
  const app = useNuxtApp();
  app.$restoreCmsUrlRoute?.();
  app.$restoreCmsUrlRoute = null;
  to.meta.cmsUrlResolution = null;
  to.meta.cmsStandalonePreview = false;
  if (!isCmsBuilderPath(to.path)) return;
  const preview = to.query?.cmsstaticcontent_preview === '1' || ['version_id', 'preview_expires', 'preview_token'].some(key => to.query?.[key] !== undefined);
  to.meta.cmsStandalonePreview = preview;
  const path = normalizeCmsPath(to.path);
  const routes = app.$appData.routes;
  if (!routes) return;
  const config = useAppConfig();
  const {matchRoute, getRoute} = useApiRoutes({route: to});
  const existing = getRoute(matchRoute(routes, path));
  const lang = useLang().get();

  if (preview) {
    if (path === '/' || path === `/${lang}/`) throw createError({statusCode: 400, data: {cmsStaticContentPreview: true}, message: 'CMS pregled zahtijeva URL stranice.'});
    if (existing && !['staticcontent', 'cmsstaticcontent'].includes(existing.controller)) throw createError({statusCode: 409, data: {cmsStaticContentPreview: true}, message: 'URL pregleda pripada drugoj vrsti stranice.'});
    to.meta.cmsUrlResolution = {source: 'cmsstaticcontent', slug: path};
  } else {
    if (!canResolveCmsRoute(existing, path)) return;
    const key = `cms-url:${config.host || ''}:${config.cmsstaticcontent?.channel || lang}:${lang}:${path}`;
    const {data, error} = await useAsyncData(key, () => useApi('/api/nuxtapi/cmsstaticcontent/resolve/', {
      method: 'GET', query: {slug: path, lang, channel: config.cmsstaticcontent?.channel || lang},
    }), {getCachedData: (key, nuxtApp) => nuxtApp.isHydrating ? nuxtApp.payload.data[key] : undefined});
    if (error?.value) throw createError({statusCode: error.value.statusCode || 502, message: 'Page URL could not be resolved.'});
    if (!data.value?.success || !['cmsstaticcontent', 'staticcontent', 'none'].includes(data.value?.data?.source)) throw createError({statusCode: 502, message: 'Page URL could not be resolved.'});
    to.meta.cmsUrlResolution = data.value.data;
  }

  const source = to.meta.cmsUrlResolution.source;
  if (source === 'none') {
    if (existing && ['staticcontent', 'cmsstaticcontent'].includes(existing.controller) && existing.path === path) app.$restoreCmsUrlRoute = replaceCmsRoute(app.$appData, path, null);
    return;
  }
  const route = {path, lang, controller: 'cmsstaticcontent', action: 'index', content: 'page', content_type: 'page'};
  app.$restoreCmsUrlRoute = replaceCmsRoute(app.$appData, path, route);
});
